var React = require('react');

function IconLater (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13.4021","cy":"13.4021","r":"6.3687","fill":"white","key":0}),React.createElement("path",{"d":"M7.03341 20.5806H3.49292V23.856","stroke":"#005646","strokeWidth":"2","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M1 13C1 6.42986 6.42986 1 13 1C19.5701 1 25 6.42986 25 13C25 19.5701 19.5701 25 13 25C9.63348 25 6.42986 23.5882 4.14932 21.1448","stroke":"#005646","strokeWidth":"2","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M13.0669 7.03345V13.1454L17.7596 18.0949","stroke":"#005646","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

IconLater.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = IconLater;

IconLater.default = IconLater;
